module.exports = __webpack_public_path__ + "static/media/3rdParty.c8b5548a.svg";